import React, { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';

const IntercomMessenger = () => {
  useEffect(() => {
    // Initialize Intercom with the app_id
    Intercom({
      app_id: 'xkgxxhfa',
    });

    // Cleanup function to shutdown Intercom when component unmounts
    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, []);

  // This component doesn't render anything visible
  // The messenger appears automatically in the bottom right
  return null;
};

export default IntercomMessenger; 